import { compose } from 'recompose';
import SalesVatReport from './SalesVatReport';
import apiInterceptor from '../../../api/interceptor';
import { salesVatApi } from '../../common/base.api';

const composedSalesVatReport = compose(apiInterceptor({ ...salesVatApi }))(SalesVatReport);

export default composedSalesVatReport;
